<template>
  <b-container fluid>
    <VisitType :organizationId="organizationId" :professionalId="null" :total="totalVisitTypes" :type="'ORGANIZATION'"
      :update="update" :visitTypes="visitTypes">
    </VisitType>
    <Box :boxes="boxes" :organizationId="organizationId" :total="totalBoxes" :update="update">
    </Box>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import VisitType from "./VisitType";
import Box from "./Box";

import organizationService from "../../services/organization";

export default {
  name: "OrganizationVisitType",
  props: {
    organizationId: "",
    update: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VisitType,
    Box,
  },
  mounted() {
    xray.index();
    this.getAllVisitTypes(this.organizationId, 0, 1000, { name: "" });
    this.getAllBoxes(this.organizationId, 0, 1000, { name: "" });
  },
  computed: {},
  methods: {
    async getAllVisitTypes(organizationId, currentPage, pageSize, filter) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.getAllVisitTypes(
          organizationId,
          currentPage,
          pageSize,
          filter
        ),
        (response) => {
          if (response) {
            self.visitTypes = response.data.content;
            self.totalVisitTypes = response.data.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllVisitTypes",
            module: "component-organization-organizationvisittype",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter
            }),
          });
        },
        " "
      );
    },
    async getAllBoxes(organizationId, currentPage, pageSize, filter) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findAllBoxes(
          organizationId,
          currentPage,
          pageSize,
          filter
        ),
        (response) => {
          if (response) {
            self.boxes = response.data.content;
            self.totalBoxes = response.data.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findAllBoxes",
            module: "component-organization-organizationvisittype",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter
            }),
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      visitTypes: [],
      boxes: [],
      totalBoxes: 0,
      totalVisitTypes: 0,
    };
  },
};
</script>
